module.exports = __webpack_public_path__ + "media/hallBgm2.ee6839d1.mp3";